import React from 'react';
import {
  TradingScoreDataContent,
  TRADING_SCORE_OPTIONS,
  TRADING_SCORE_STYLES,
} from './types';

interface TradingScoreSummaryProps {
  data: unknown;
  config: Record<string, unknown>;
}

const TradingScoreSummary: React.FC<TradingScoreSummaryProps> = ({ data }) => {
  const content = data as TradingScoreDataContent | undefined;
  const action = content?.action;

  if (!action) {
    return <span className="text-neutral-300">—</span>;
  }

  const option = TRADING_SCORE_OPTIONS.find((item) => item.value === action);
  const styles = TRADING_SCORE_STYLES[action];

  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold whitespace-nowrap ${styles.badge}`}>
      {option?.label ?? action}
    </span>
  );
};

export default TradingScoreSummary;
